<template>
  <div class="si-breadcrumb">
    <router-link :to="homeLink">{{ breadcrumb.home }}</router-link>
    <template v-if="showProducts">
      <span>/</span>
      <router-link :to="siLink">{{ breadcrumb.products }}</router-link>
    </template>
    <template v-if="showSi">
      <span>/</span>
      <router-link :to="siLink">{{ breadcrumb.si }}</router-link>
    </template>
    <template v-if="current">
      <span>/</span>
      <strong>{{ current }}</strong>
    </template>
  </div>
</template>

<script>
export default {
  name: 'SIBreadcrumb',
  props: {
    breadcrumb: {
      type: Object,
      required: true,
    },
    locale: {
      type: String,
      default: '',
    },
    current: {
      type: String,
      default: '',
    },
    showSi: {
      type: Boolean,
      default: true,
    },
    showProducts: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    homeLink() {
      return {
        name: 'home',
        params: { lang: this.locale || undefined },
      };
    },
    siLink() {
      return {
        name: 'si',
        params: { lang: this.locale || undefined },
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.si-breadcrumb {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  line-height: 20px;
  color: #a7aeb1;

  a,
  strong {
    color: inherit;
    text-decoration: none;
  }

  strong {
    color: #ffffff;
    font-weight: 500;
  }
}
</style>
